import StatCard from '../../dashboard/components/StatCard';
import type { AdminDashboardStats } from '../../../domain/superadmin/types';

export function DashboardKpiRow({ kpis }: { kpis: AdminDashboardStats['kpis'] }) {
  return (
    <section aria-label="Indicadores" className="mb-s5 grid grid-cols-1 gap-s3 sm:grid-cols-2 xl:grid-cols-5">
      <StatCard
        title="Total de clientes"
        value={String(kpis.clientsTotal)}
        change={0}
        period="no período"
        baseValue="-"
        icon="users"
        accent="brand"
      />
      <StatCard
        title="Taxa de churn"
        value={`${kpis.churnRate.toFixed(1)}%`}
        change={0}
        period="estoque"
        baseValue="-"
        icon="alert"
        accent="brand"
      />
      <StatCard
        title="Crescimento"
        value={`${kpis.growthRate.toFixed(1)}%`}
        change={kpis.growthRate}
        period="no período"
        baseValue="-"
        icon="chart"
        accent="success"
      />
      <StatCard
        title="Em Trial"
        value={String(kpis.trialsActive)}
        change={0}
        period="ativos"
        baseValue="-"
        icon="clock"
      />
      <StatCard
        title="Recorrência média"
        value={`${kpis.avgRecurrenceMonths.toFixed(1)} mês`}
        change={0}
        period="ativos pagos"
        baseValue="-"
        icon="calendar"
      />
    </section>
  );
}
